
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"22","viewBox":"0 0 24 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.84826 11.2826C2.24395 10.7059 1.76794 10.0128 1.45021 9.24682C1.13248 8.48087 0.979915 7.6587 1.00212 6.83209C1.02432 6.00547 1.22081 5.19232 1.57922 4.44384C1.93763 3.69535 2.45019 3.02774 3.08462 2.48306C3.71905 1.93838 4.46162 1.52842 5.26555 1.27899C6.06949 1.02957 6.91738 0.946081 7.75583 1.03379C8.59429 1.1215 9.40514 1.37851 10.1373 1.78863C10.8695 2.19876 11.5072 2.75311 12.0102 3.41678C12.5153 2.75793 13.1538 2.20842 13.8854 1.80265C14.6171 1.39688 15.4263 1.14358 16.2624 1.05861C17.0985 0.973642 17.9435 1.05883 18.7445 1.30883C19.5455 1.55884 20.2853 1.96829 20.9175 2.51155C21.5497 3.05482 22.0607 3.7202 22.4186 4.46606C22.7766 5.21193 22.9736 6.02221 22.9975 6.84619C23.0214 7.67018 22.8716 8.49014 22.5575 9.25475C22.2434 10.0194 21.7718 10.7122 21.1721 11.2898L12.7375 20.2289C12.3427 20.6473 11.6771 20.6471 11.2825 20.2286L2.84826 11.2826Z"}})])
          )
        }
      }
    